import React from 'react';
import styles from './profileInfo.module.css';


const ProfileInfo = () => { 
return ( 
 <div className={styles.profile}> 
 </div> 
)}
 
export default ProfileInfo;
